import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * アポイントメントデータ一覧
 *
 * 自分が所持しているアポイントメントの一覧を返す
 */
export class FetchAppointment implements APIRequest<Monitaro.FetchAppointmentResponse> {
  response: Monitaro.FetchAppointmentResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/appointments`
  }
}

/**
 * アポイントメント申請
 *
 * 病院管理者からアポイントの申請を行う
 */
export class PostAppointment implements APIRequest<Monitaro.PostAppointmentResponse> {
  response: Monitaro.PostAppointmentResponse
  path: string
  contentType = 'multipart/form-data'
  method = HTTPMethod.POST
  params: Monitaro.AppointmentRequest
  constructor(params: Monitaro.AppointmentRequest) {
    this.params = params
    this.path = `/appointments`
  }
}

/**
 * マイカレンダーデータ一覧
 *
 * マイカレンダーのデータを返す
 */
export class FetchAppointmentCalendar implements APIRequest<Monitaro.FetchAppointmentCalendarResponse> {
  response: Monitaro.FetchAppointmentCalendarResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/appointments/calendar`
  }
}

/**
 * アポイントメントデータの取得
 *
 * 指定されたアポイントメントIDのデータを取得する&lt;br&gt;
保有していないアポイントメントIDの場合はステータス404を返す
 */
export class GetAppointment implements APIRequest<Monitaro.GetAppointmentResponse> {
  response: Monitaro.GetAppointmentResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(appointment: string) {
    this.path = `/appointments/${appointment}`
  }
}

/**
 * アポイントメントデータの更新
 *
 * アポイントメントのデータの更新を行う
 */
export class PutAppointment implements APIRequest<Monitaro.PutAppointmentResponse> {
  response: Monitaro.PutAppointmentResponse
  path: string
  contentType = 'multipart/form-data'
  method = HTTPMethod.PUT
  params: Monitaro.AppointmentRequest
  constructor(appointment: string, params: Monitaro.AppointmentRequest) {
    this.params = params
    this.path = `/appointments/${appointment}`
  }
}

/**
 * アポイントメントデータの削除
 *
 * アポイントメントデータを削除する
 */
export class DeleteAppointment implements APIRequest<Monitaro.DeleteAppointmentResponse> {
  response: Monitaro.DeleteAppointmentResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.DELETE
  constructor(appointment: string) {
    this.path = `/appointments/${appointment}`
  }
}
